// Feature flag configuration

// Car park CSV export feature flag
const carparkCsvExportFlag = import.meta.env.CARPARK_CSV_EXPORT_FLAG as string;
export const isCarparkCsvExportEnabled = carparkCsvExportFlag === "true";

// Maintenance & Repair module feature flag (FRNT-5901).
// This is the single flag for the whole M&R module — downstream M&R tickets
// should import and gate on `isMnrEnabled` rather than declaring a new flag.
const mnrFlag = import.meta.env.MNR_FLAG as string;
export const isMnrEnabled = mnrFlag === "true";

// M&R Phase 2 flag (FRNT-6302). Phase 1 is the landing page and Issue CRUD;
// everything else in M&R must gate on `isMnrPhase2Enabled`. Default OFF.
// Toggled via the MNR_PHASE2_FLAG env var ("true" to enable).
const mnrPhase2Flag = import.meta.env.MNR_PHASE2_FLAG as string;
export const isMnrPhase2Enabled = mnrPhase2Flag === "true";

// "Log in as Workshop" bypass button on the login screen (FRNT-5926), for
// QA-testing the workshop-only flow without a backend account that has
// permission 14. Keep this off outside local/staging.
const wshopLoginBypassFlag = import.meta.env.WSHOP_LOGIN_BYPASS_FLAG as string;
export const isWshopLoginBypassEnabled = wshopLoginBypassFlag === "true";
